import {BehaviorSubject, from} from 'rxjs';
import {startWith} from 'rxjs/operators';

BehaviorSubject.prototype.set = BehaviorSubject.prototype.next;

Promise.prototype.toRestState = function () {
  return from(this).pipe(startWith({loading: true}));
};
